import classnames from 'classnames';

import './style.scss';

const PREFIX = 'music';
const USER_ICON = 'https://akoss.bangcdn.net/fe/User.svg';

export type AvatarSize = 'small' | 'medium' | 'large';

export interface AvatarProps {
  /** 头像图片 URL */
  src?: string;
  /** 尺寸：small=32px, medium=40px, large=80px */
  size?: AvatarSize;
  /** 自定义类名 */
  className?: string;
  /** 替代文字 */
  alt?: string;
  /** 点击回调 */
  onClick?: () => void;
}

const SIZE_MAP: Record<AvatarSize, number> = {
  small: 32,
  medium: 40,
  large: 80,
};

export default function Avatar({ src, size = 'large', className, alt = 'avatar', onClick }: AvatarProps) {
  const avatarSize = SIZE_MAP[size];
  
  return (
    <div
      className={classnames(
        `${PREFIX}-avatar`,
        `${PREFIX}-avatar--${size}`,
        { [`${PREFIX}-avatar--clickable`]: !!onClick },
        className
      )}
      style={{ width: avatarSize, height: avatarSize }}
      onClick={onClick}
    >
      {src ? (
        <img src={src} alt={alt} className={`${PREFIX}-avatar__image`} />
      ) : (
        <div className={`${PREFIX}-avatar__placeholder`}>
          <img src={USER_ICON} alt="" />
        </div>
      )}
    </div>
  );
}
